import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { IonIcon } from '@ionic/angular/standalone';
import { TranslatePipe } from '@core/i18n';
import { ClientMobileTab } from './client-mobile-tabbar.models';

@Component({
  selector: 'app-client-mobile-tabbar',
  standalone: true,
  imports: [IonIcon, RouterLink, RouterLinkActive, TranslatePipe],
  templateUrl: './client-mobile-tabbar.component.html',
  host: { class: 'pointer-events-none block' },
})
export class ClientMobileTabbarComponent {
  readonly tabs: ClientMobileTab[] = [
    { id: 'home', labelKey: 'nav.home', icon: 'home-outline', route: '/home' },
    { id: 'rooms', labelKey: 'nav.rooms', icon: 'bed-outline', route: '/rooms' },
    { id: 'book', labelKey: 'mobile.tabbar.book', icon: 'add-outline', route: '/book', center: true },
    { id: 'bookings', labelKey: 'mobile.tabbar.bookings', icon: 'calendar-outline', route: '/my-bookings' },
    { id: 'profile', labelKey: 'common.profile', icon: 'person-outline', route: '/profile' },
  ];

  readonly centerTab = this.tabs.find((tab) => tab.center);
}
